import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import type { AnyAction } from '@reduxjs/toolkit';
import { addInsightAction } from '../../../../store/ai2';
import type { ActionInsightRequest } from '../../../../lib';

export const useInsights = () => {
  const dispatch = useDispatch();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get('access_token');

  const handleSubmitInsight = async (action: any): Promise<boolean> => {
    try {
      if (accessToken && action.action_status !== '-Select-') {
        action.access_token = accessToken;
        const request: ActionInsightRequest = action;
        await dispatch(
          addInsightAction(request, selectedTenancy) as unknown as AnyAction,
        );
      }
      return true;
    } catch (error) {
      return false;
    }
  };
  return { handleSubmitInsight };
};
